var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.155,
    height: 11.155,
    viewBox: "0 0 11.155 11.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-square",
    "data-name": "Icon awesome-check-square",
    d: "M9.96,13.405H1.2A1.2,1.2,0,0,1,0,12.21V3.445a1.2,1.2,0,0,1,1.2-1.2H9.96a1.2,1.2,0,0,1,1.2,1.2V12.21A1.2,1.2,0,0,1,9.96,13.405Zm-5.1-2.442L9.445,6.382a.4.4,0,0,0,0-.563l-.563-.563a.4.4,0,0,0-.563,0L4.582,8.992,2.837,7.247a.4.4,0,0,0-.563,0l-.563.563a.4.4,0,0,0,0,.563l2.59,2.59a.4.4,0,0,0,.563,0Z",
    transform: "translate(0 -2.25)",
    fill: "#01a9e0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.fbb238ad2960cfeda4e0db8426df9ba6.svg";
export { ForwardRef as ReactComponent };